import React from 'react'
import Translate from 'App/i18n'
import {verifyEmail} from 'meteor-apollo-accounts'
import autobind from 'autobind-decorator'
import {withApollo} from 'react-apollo'
import PropTypes from 'prop-types'
import styles from './styles.css'


@withApollo
export default class VerifyEmail extends React.Component {

  static propTypes = {
    setLoading: PropTypes.func,
    isLoading: PropTypes.bool,
    token: PropTypes.string,
    id: PropTypes.string,
    user: PropTypes.string,
    onSuccess: PropTypes.func,
    client: PropTypes.object,
  }

  state = {}

  componentDidMount () {
    console.log("Verificando token");
    this.verify()
  }

  // salida() {
  //    window.location.href='../forgot'    
  // }
  reload() {
     window.location.reload()
  }

  linkDoc(){
    const token = this.props.token
    const user = this.props.user
    if(user){
      if(user === '1'){
        const linkReplace = window.location.href.replace('/verify-email/' + token + '/' + user, '/sign')
        return window.location.href = linkReplace
      }
      if(user === 'tF'){
        const linkReplace = window.location.href.replace('/verify-email/' + token + '/' + user, '/documents')
        return window.location.href = linkReplace
      }
      if(user === 'fea'){
        const linkReplace = window.location.href.replace('/verify-email/' + token + '/' + user, '/documents')
        return window.location.href = linkReplace + '/preview'
      }
      const linkReplace = window.location.href.replace('/verify-email/' + token + '/' + user, '/documents') + '/preview'
      return window.location.href = linkReplace
    } else {
      const linkReplace = window.location.href.replace('/verify-email/' + token, '/')
      return window.location.href = linkReplace;
    }
  }

  loginToken(){
    const user = this.props.user
    if(user){
      return this.linkDoc()
    } else {
      console.log("No tengo user, esperare didmount");
    }
    return null;
  }

  @autobind
  async verify () {
    const token = this.props.token
    console.log("VerifyEmail-Verify");

    try {
      this.props.setLoading(true)
      console.log("Realizare verificacion de correo");
      await verifyEmail({token: token}, this.props.client)
      console.log("verificado correo");
      this.props.client.resetStore()
      this.linkDoc()
    } catch (error) {
      this.setState({error: error.message})
      this.props.setLoading(false) 
    }
  }
  
  render () {
    console.log("VerifyEmail-render");
    const id = this.props.id
    const lT = localStorage.getItem('Meteor.loginToken')

    if(this.state.error && id && lT){
      return this.linkDoc()
    }
    console.log("aca");
    if(lT && !id){
      console.log("Entra ");
      return this.loginToken();
    }

    console.log("al if");
    if(this.state.error && id && !lT){
      console.log("error e id y !lt");
      return(
        <div id="root">
          <div className=''> 
            <div className='center-align'>                
                Por favor inicia sesión.<br/>
                Selecciona las siguientes opciones:
                <div className='centerOptions'>
                  <ul>
                    <li><Translate tr="auth.pages.otherLinksInRegister" /></li>
                    <li><Translate tr="auth.pages.otherLinkForgetPassword" /></li>
                    <li><Translate tr="auth.logintoken.LoginToken" /></li>
                  </ul>
                </div>
            </div>
          </div>
        </div>
      )
    }

    if (this.state.error) {
      console.log("solo error");
      return ( 
          <div id="root">
            <div className=''> 
              <div className='center-align'>                
                  El link de verificación caducó.<br/>
                  Selecciona las siguientes opciones:
                  <div className='centerOptions'>
                    <ul>
                      <li><Translate tr="auth.pages.otherLinkForgetPassword" /></li>
                      <li><Translate tr="auth.logintoken.LoginToken" /></li>
                    </ul>
                  </div>
              </div>
            </div>
           </div>
      )
    }
      else{
        console.log("else");
        return (
          <div className='center-align'>
            <Translate tr='auth.verifyEmail.verifying' />
          </div>
        )
      }
  }

}



// WEBPACK FOOTER //
// ./src/App/Pages/Auth/VerifyEmail.js